
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import TileContent from './TileContent';

const classNames = mergeStyleSets({
    contacts: {
        color: '#888888'
    },
    name: {
        width: 100,
    },
    value: {
        //width: 250,
    },
    text: {
        //width: 400,
    },
});

const Item = ({name, text, value}) => {
    return (text)
        ? (
            <Stack horizontal>
                <Stack.Item className={classNames.text}>{text}</Stack.Item>
            </Stack>
        )
        : (
            <Stack horizontal>
                <Stack.Item className={classNames.name}>{name} :</Stack.Item>
                <Stack.Item className={classNames.value}>{value}</Stack.Item>
            </Stack>
        );

}

const TileContacts = () => {
    return (
        <TileContent title="Kontakt">
            <Stack horizontal tokens={{childrenGap: 8}} className={classNames.contacts}>
                <Stack.Item grow>
                    <Stack>
                        <Item text="HF Biz s.r.o." />
                        <Item text="Slovanská 255/21, Šumperk, 787 01" />
                        <Item text="IČO: 27836649" />
                        <Item text="DIČ: CZ27836649" />
                    </Stack>
                </Stack.Item>
                <Stack.Item grow>
                <Stack>
                    <Item text="Ing. Pavel Sedlář" />
                    <Item text="+420 603 496 850" />
                    <Item text="webhonitba[zavináč]mysliveckyportal.cz" />
                </Stack>
                </Stack.Item>
                <Stack.Item grow>
                <Stack>
                    <Item text="Barbora Hajduková" />
                    <Item text="+420 739 038 673" />
                    <Item text="hajdukova[zavináč]hfbiz.cz" />
                </Stack>
                </Stack.Item>
            </Stack>
        </TileContent>
    );
}

export default TileContacts;
